import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import _ from 'lodash';

import dateUtils from '../../../util/dates';
import dataUtils from '../../../util/dataUtils';
import highchartFactory from '../../../util/highcharts';
const highchartUtils = highchartFactory();

const chartConfig = {
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: '#fff',
    type: 'scatter',
  },
  title: {
    text: '',
  },
  xAxis: {
    type: 'datetime',
    labels: {
      style: {
        fontSize: '12px',
      },
    },
    tickmarkPlacement: 'on',
    title: {
      enabled: false,
    },
  },
  yAxis: {
    opposite: false,
    allowDecimals: false,
    gridLineColor: '#F5F5F5',
    gridLineWidth: 1,

    title: {
      enabled: false,
    },
    labels: {
      style: {
        fontSize: '12px',
      },
    },
    plotLines: [],
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    series: {
      stickyTracking: false,
    },
    scatter: {
      marker: {
        symbol: 'circle',
        radius: 3,
        states: {
          hover: {
            lineColor: 'rgb(100,100,100)',
          },
        },
      },
      states: {
        hover: {
          marker: {
            enabled: false,
          },
        },
      },
    },
  },
  series: [],
};

class CTSPChart extends React.Component {
  componentDidMount() {
    this.chart = new Highcharts['Chart'](`${this.props.id}-details`, chartConfig);

    this.updateTimeLabelsFormat(this.props.dateFormat);

    if (this.props.data.series) {
      this.updateChart();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.updateChart(prevProps.data);
    }

    if (prevProps.dateFormat != this.props.dateFormat) {
      this.updateTimeLabelsFormat(this.props.dateFormat);
    }
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  updateChart(oldData = {}) {
    _.forEach(this.props.data.series, (s) => {
      delete s.marker;
    });

    const diff = dataUtils.getDiff(oldData.series, this.props.data.series, 'data');
    highchartUtils.updateSeries(diff, this.chart);

    this.chart.redraw();
  }

  updateTimeLabelsFormat(dateFormat) {
    let config = { xAxis: {} };
    config.xAxis.dateTimeLabelFormats = dateUtils.createHighchartFormats(dateFormat);

    this.chart.update(config);
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.className}>
        <div>
          <div id={`${this.props.id}-details`}></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    colorsEnabled: state.filters.ctsp.colorsEnabled,
    dateFormat: state.filters.dateFormat,
  };
};

export default connect(mapStateToProps)(CTSPChart);
